export default "__VITE_ASSET__C6Hd1Ply__"